export default "__VITE_ASSET__Btvuk1$q__"